import React, { useState, Fragment, useEffect } from "react";
import { Button } from "reactstrap";
import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Analytics from "./Analytics";
import CratioTooltip from "../../Common/CratioTooltip";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import { randstr } from "../../Common/Appcommon";
import requestApi from "../../services/requestApi.service";
import loader from "../../assets/utils/images/loader-camp-count.gif"

const AnalyticsContent = (props) => {
    const { totalCount, sentCount, deliveredCount, ReadCount, repliedCount, viewLink, formId, source, analyticsConfig } = props;
    const showOnlyRecipients = analyticsConfig ? analyticsConfig.showOnlyRecipients : false;

    const [campSentCount, setSendCount] = useState(sentCount !== undefined ? sentCount : "Loading");
    const [campDeliveredCount, setDeliveredCount] = useState(deliveredCount !== undefined ? deliveredCount : "Loading");
    const [campReadCount, setReadCount] = useState(ReadCount !== undefined ? ReadCount : "Loading");
    const [campRepliedCount, setRepliedCount] = useState(repliedCount !== undefined ? repliedCount : "Loading");
    const [campRetriedCount, setRetriedCount] = useState("Loading");
    const [campTotalCount, setTotalCount] = useState(totalCount !== undefined ? totalCount : "Loading");

    useEffect(() => {
        (async () => {
            await getAnalyticsSummary(source, formId);
        })();
        return () => {
            // this now gets called when the component unmounts
        };
    }, []);

    const openLink = (link) => {
        window.open(
            link,
            '_blank' // <- This is what makes it open in a new window.
        );
    }
    const openStatusLink = (name) => {
        window.open(
            "#/deliverylog/" + source + "/" + formId + "/" + name,
            '_self' // <- This is what makes it open in a new window.
        );
    }

    const getAnalyticsSummary = async (formlabel, formid) => {

        let customCondition = formlabel + "#" + formid;
        let convformname = process.env.REACT_APP_CONVERSATION_FORMNAME;

        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "WHATSAPP_CAMPAIGN_SUMMARY",
            "FORMNAME": convformname,
            "customCondition": customCondition
        };

        let response = await requestApi.processServerRequest(params, 'WebV2', 'post');
        if (response.issuccess) {
            let data = response.data;

            for (let key in data) {
                if (key === "sent") {
                    setSendCount(data[key]);
                } else if (key === "delivered") {
                    setDeliveredCount(data[key]);
                } else if (key === "read") {
                    setReadCount(data[key]);
                } else if (key === "replied") {
                    setRepliedCount(data[key]);
                } else if (key === "retry") {
                    setRetriedCount(data[key]);
                } else if (key === "totalcount") {
                    setTotalCount(data[key]);
                };
            }
        }
    }


    return (
        <div className={'analytics-data'}>
            <Button className="mb-2 me-2 mr-3 btn-icon-vertical btn-shadow btn-dashed" outline color="primary">
                <i className="btn-icon-wrapper">{
                    campTotalCount === "Loading" ? <img src={loader} alt="Loading.." /> : Number(campTotalCount).toLocaleString()}
                </i>
                <span className={'d-inline-flex'}>
                    RECIPIENTS
                    <CratioTooltip id={randstr('cam_ana_')} title={"The total count of recipients to whom a message was scheduled to be sent."} content={<FontAwesomeIcon className={'info-icon '} icon={faCircleInfo} />} />
                </span>
            </Button>
            <Button onClick={(e) => { openStatusLink("sent") }} className="mb-2 me-2 mr-3 btn-icon-vertical btn-shadow btn-dashed" outline color="success" >
                <i className=" btn-icon-wrapper">{
                    campSentCount === "Loading" ? <img src={loader} alt="Loading.." /> : Number(campSentCount).toLocaleString()}
                </i>
                <span className={'d-inline-flex'}>
                    SENT
                    <CratioTooltip id={randstr('cam_ana_')} title={"The total number of messages that were sent. Please note that recipients without a WhatsApp account or who have unsubscribed from your marketing were skipped automatically."} content={<FontAwesomeIcon className={'info-icon '} icon={faCircleInfo} />} />
                </span>
            </Button>
            <Button
                onClick={(e) => {  openStatusLink("delivered") }}
                className="mb-2 me-2 mr-3 btn-icon-vertical btn-shadow btn-dashed"
                outline
                color="warning"
                style={{ pointerEvents: "auto", opacity: 1 }}
                >
                <i className={"btn-icon-wrapper"}>
                    { (campDeliveredCount === "Loading" ? <img src={loader} alt="Loading.." /> : Number(campDeliveredCount).toLocaleString())}
                </i>
                    DELIVERED
            </Button>
            <Button
                        onClick={(e) => { openStatusLink("read") }}
                        className="mb-2 me-2 mr-3 btn-icon-vertical btn-shadow btn-dashed"
                        outline
                        color="info"
                        style={{ pointerEvents:  "auto", opacity: 1 }}
                    >
                        <i className={"btn-icon-wrapper"}>
                            {
                                (campReadCount === "Loading"
                                        ? <img src={loader} alt="Loading.." />
                                        : Number(campReadCount).toLocaleString())
                            }
                        </i>
                        READ
                    </Button>

                    {/* REPLIED */}
                    <Button
                        onClick={(e) => { openStatusLink("replied") }}
                        className="mb-2 me-2 mr-3 btn-icon-vertical btn-shadow btn-dashed"
                        outline
                        color="alternate"
                        style={{ pointerEvents: "auto", opacity: 1 }}
                    >
                        <i className={"btn-icon-wrapper"}>
                            {
                                (campRepliedCount === "Loading"
                                        ? <img src={loader} alt="Loading.." />
                                        : Number(campRepliedCount).toLocaleString())
                            }
                        </i>
                        REPLIED
                    </Button>

                    {/* RETRY */}
            <Button
                        onClick={(e) => { if (!showOnlyRecipients) openStatusLink("retried") }}
                        className="mb-2 me-2 mr-3 btn-icon-vertical btn-shadow btn-dashed"
                        outline
                        color="alternate"
                        style={{ pointerEvents: showOnlyRecipients ? "none" : "auto", opacity: showOnlyRecipients ? 0.6 : 1 }}
                    >
                         <i className={showOnlyRecipients ? "d-block" : "btn-icon-wrapper"}>
                            {
                                showOnlyRecipients
                                    ? "Coming Soon"
                                    : (campRetriedCount === "Loading"
                                        ? <img src={loader} alt="Loading.." />
                                        : Number(campRetriedCount).toLocaleString())
                            }
                        </i>
                        RETRY
             </Button>                                  
            <Button onClick={(e) => { openLink(viewLink) }} className=" mb-2 me-2 btn-icon-vertical btn-shadow btn-dashed custom-btn-outline-analytics6 custom-btn-shadow-analytics6" outline >
                <i className="pe-7s-link btn-icon-wrapper"> </i>
                VIEW LOG
            </Button>
        </div>
    )
}

export default AnalyticsContent;
